<style scoped>
	div{box-sizing: border-box;}
	.cgLis{ width: 100%;display: flex;flex-direction: row;flex-wrap: wrap;padding: 20px; }
	.cgLis_item{ width: 20%; padding: 15px;box-sizing: border-box;	}
	.title{background-image: url(../../../../public/icon/001.png);background-size: cover;
	background-repeat: no-repeat;height: 50px;color: #fff;text-align: center;line-height: 50px;width: 150px;}
	.userD{ display: flex;flex-direction: row; background-color: #f2f2f2;}
	.userPohot{ padding: 10px;cursor: pointer;}
	.userPohot img{ width: 50px!important;height: 50px;border-radius: 50%; }
	.uname{ display: inline-flex;align-items: center; }
	.anImg:hover{ transform: scale(1.12);cursor: pointer; }
</style>
<template>
	<div class="template" style="padding: 30px 60px;">
		<div class="title">设计成果</div>
		<div class="cgLis">
			<div class="cgLis_item" v-for="an in anliArr">
				<img  @click="seePhoto(an)" class="anImg" :src="imgAPI+an.imgUrlArr[0]" style="width: 100%;" />
				<div class="userD" @click="usersWorks(an)">
					<div class="userPohot">
						<img :src="an.headimg?imgAPI+an.headimg:require('../../../../public/icon/001.jpg')" style="width: 100%;" />
					</div>
					<div class="uname">{{an.nickname}}</div>
				</div>
			</div>
		</div>
		<el-dialog title="" :show-close="false" :visible.sync="seePhotoDlog" class="myDlog myDlog_opa" :fullscreen="true">
			<worksInfoDlog :pageParams="pageParams" v-on:parentMethod="communication" v-if="seePhotoDlog"></worksInfoDlog>
		</el-dialog>
	</div>
</template>

<script>
	import baseConst from '../../../assets/js/baseConst.js' //注意路
	const worksInfoDlog = () =>
		import("@/components/home/works/works_info.vue"); //作品详情
	export default{
		components: {
			worksInfoDlog
		},
		data(){
			return{
				anliArr:[],
				pTotla:0,
				imgAPI: '',
				seePhotoDlog:false,
				pageParams:{},
			}
		},
		created:function(){
			let _this = this;
			_this.imgAPI = baseConst.IMG_API;
			_this.getDesignLise();
		},
		mounted:function(){
			let _this = this;
		},
		methods:{
			/*获取设计案例
			 创建于2019-11-25  作者：郑凯*/
			getDesignLise() {
				let _this = this;
				let params = {
					limit: 200,
					pageNumber: 1
				};
				_this.getApi('/api/getDesignWorksList', params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.anliArr = res.data.data;
							_this.pTotla = res.data.total;
							for(let i = 0; i < _this.anliArr.length; i++) {
								let imgUrlArr = [];
								imgUrlArr = _this.anliArr[i].works.split('|');
								_this.anliArr[i].imgUrlArr = imgUrlArr;
							}
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/**  * -----查看图片
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seePhoto(obj) {
				let _this = this;
				_this.pageParams = JSON.parse(JSON.stringify(obj));
				_this.seePhotoDlog = true;
				setTimeout(function() {
					document.getElementsByClassName("el-dialog__body")[0].scrollTop = 0;
				}, 100)
			},
			/**  * -----这个组件的子组件通信处理    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			communication(type) {
				let _this = this;
				switch(type) {
					case 'works_info':
						_this.seePhotoDlog = false;
						break;
					default:
				}
			},
			/*查看设计师的作品
			 创建于2019-11-25  作者：郑凯*/
			usersWorks(ob) {
				let _this = this;
				_this.$router.push({
					name: 'works_user',
					　　　　query: {
						pagePrams: JSON.stringify(ob)
					}
				})
			},
		}
	}
</script>